import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';
import CustomModal from '../../../Components/Components/Modal';

import coinImg from '../../../../../../images/redesign/common/coin.svg';
import giftBackImg from '../../../../../../images/redesign/my-info/my-info-gift-bg.png';
import { GIFTS_ITEMS, GIFTS_TAB, SCREENS } from '../../../../../../constants/constants';
import CustomDropdown from '../../../Components/Components/CustomDropdown';
import { DropdownItem } from 'reactstrap/lib';
import { UncontrolledTooltip } from 'reactstrap';
import config from '../../../../../../constants/config';
import { isEqual } from 'lodash';
import { setUserScreenViewNew } from '../../../../../../actions/member';
import { setClosePlayerModalTrigger } from '../../../../../../actions/state';

class SendGiftMobile extends Component {
  static propTypes = {
    sendGift: PropTypes.func.isRequired,
    playButtonSound: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    gifts: PropTypes.shape(),
    notificationSettings: PropTypes.shape(),
    modalOpen: PropTypes.bool,
    fourPRoom: PropTypes.bool,
    roomId: PropTypes.string,
    giftPlayerUid: PropTypes.string,
    uid: PropTypes.string,
    popularGifts: PropTypes.shape({}),
    studentZole: PropTypes.bool,
    tournamentRoom: PropTypes.bool,
    disableDrinkGifts: PropTypes.bool,
  }

  static defaultProps = {
    gifts: {},
    notificationSettings: {},
    modalOpen: false,
    fourPRoom: false,
    roomId: null,
    giftPlayerUid: null,
    uid: null,
    popularGifts: {},
    studentZole: false,
    disableDrinkGifts: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      giftId: '',
      sendingGift: false,
      activeItem: 'popular',
      isOpenGiftsTab: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { players, setScreenViewNew } = this.props;

    if (this.props.modalOpen && !prevProps.modalOpen) {
      setScreenViewNew(SCREENS.ACTIVE_ROOM.GIFTS);
    }
  }

  sendGift = (giftId, drink) => {
    const {
      sendGift, roomId, playButtonSound, giftPlayerUid, setClosePlayerModalTriggerFunc,
    } = this.props;
    const {
      sendingGift,
    } = this.state;

    this.setState({ confirmationModal: false });

    if (!sendingGift && giftPlayerUid && giftId) {
      playButtonSound();

      this.setState({ sendingGift: true });

      sendGift(roomId, giftId, [giftPlayerUid], drink).then((res) => {
        if (res === 'success') {
          this.setState({
            giftSent: true,
          });
          this.closeModal();
          setClosePlayerModalTriggerFunc(true);
        }
        this.setState({ sendingGift: false });
      }).catch(() => {
        this.setState({ sendingGift: false });
      });
    }
  }

  closeModal = () => {
    const { toggle, playButtonSound } = this.props;

    playButtonSound();

    this.setState({
      giftId: '',
      confirmationModal: false,
  });

    toggle(null, false);
  }

  startSendingGift = (giftId, drink) => {
    const { notificationSettings, playButtonSound } = this.props;
    playButtonSound();

    if (notificationSettings && notificationSettings.purchaseGift === false) {
      this.sendGift(giftId, drink);
    } else {
      this.setState({ giftId, drink });
      this.toggleConfirmModal(giftId, drink);
    }
  }

  toggleConfirmModal = (key, drink) => {
    const { gifts, drinkGifts } = this.props;
    const gift = drink ? drinkGifts[key] : gifts[key];

    this.setState(prevState => ({ 
      confirmationModal: !prevState.confirmationModal,
      totalPrice: gift?.price,
    }));
  }

  toggleOpenGiftsTab= () => {
    this.setState(prevState => ({
      isOpenGiftsTab: !prevState.isOpenGiftsTab,
    }));
  }

  toggleActiveItem = (key) => {
    const { activeItem } = this.state;
    if (activeItem !== key) {
      this.setState({
        activeItem: key,
      });
    }
  }

  render() {
    const {
      gifts,
      t,
      modalOpen,
      popularGifts,
      drinkGifts,
      tournamentRoom,
      disableDrinkGifts,
    } = this.props;

    const {
      giftId,
      confirmationModal,
      totalPrice,
      activeItem,
      isOpenGiftsTab,
      drink,
    } = this.state;

    return (
      <div>
        <CustomModal
          addClassName="send-gift-mobile-section"
          isOpen={modalOpen}
          toggle={this.closeModal}
          size="lg"
          title={t('gifts.gifts')}
          footerClose
          footer={
            <Button className="modal-footer-button" onClick={this.closeModal}>
              {t('home.close')}
            </Button>
          }
          body={(
            <div className="send-gifts">
              <Row>
                <div className='d-flex flex-row no-wrap w-full px-3 gap-2 send-gifts-list-mobile-tab'>
                  <CustomDropdown
                    toggle={(
                      <span>
                        {
                          t(`gifts.${activeItem}`)
                        }
                      </span>
                    )
                    }
                    toggleFunc={this.toggleOpenGiftsTab}
                    isOpen={isOpenGiftsTab}
                    menu={(
                      <>
                        {GIFTS_TAB.map((item, key) => (
                          <DropdownItem key={key} className={activeItem === item ? 'active-item' : ''} onClick={() => { this.toggleActiveItem(item); }}>
                          {t(`gifts.${item}`)}
                        </DropdownItem>
                      ))}
                      </>
                      )}
                    inlineMenuClassName="landing-help-page-dropdown-list"
                  />
                </div>
              </Row>
              <Row className="send-gifts-list-mobile">
                <Col xs="12" className="send-gifts-list-mobile-section">
                  {activeItem === 'popular' ? (
                    popularGifts && Object.keys(popularGifts).map(key => (
                      <div
                        key={key}
                        className={`gifts-gift-item ${giftId === key ? 'gifts-gift-item-selected' : ''}`}
                        onClick={() => this.startSendingGift(key)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Media src={giftBackImg} className="gifts-gift-image-bg" />
                        <Media src={popularGifts[key].image} className="gifts-gift-image" />
                      </div>
                    ))
                  ) : (
                    <>
                      {GIFTS_ITEMS[activeItem] && GIFTS_ITEMS[activeItem].map((item, key) => {
                        if (!gifts[item]) return;

                        return (

                          <div
                            key={item}
                            className={`gifts-gift-item ${giftId === item && !drink ? 'gifts-gift-item-selected' : ''}`}
                            onClick={() => this.startSendingGift(item)}
                            style={{ cursor: 'pointer' }}
                          >
                            <Media src={giftBackImg} className="gifts-gift-image-bg" />
                            <Media src={gifts[item].image} className="gifts-gift-image" />
                          </div>
                        )})}
                      
                        {activeItem === 'foodAndDrinks' && drinkGifts && !disableDrinkGifts && !tournamentRoom && Object.keys(drinkGifts).map(item => (
                          <div
                            key={`drinks-${item}`}
                            className={`gifts-gift-item ${giftId === item && drink ? 'gifts-gift-item-selected' : ''}`}
                            onClick={() => this.startSendingGift(item, item)}
                            style={{ cursor: 'pointer' }}
                            id={`drink-${item}`}
                          >
                            <Media src={giftBackImg} className="gifts-gift-image-bg" />
                            <Media src={drinkGifts[item].image} className="gifts-gift-image"  />
                            <div className="gifts-gift-pricebox-new">
                              <Media src={coinImg} />
                              {drinkGifts[item].price}
                            </div>
                            {config.isInAppFrame() && (
                              <UncontrolledTooltip
                                className="giftsHistory-tooltip player-receivedGift-tooltip-new player-receivedGift-tooltip-new-player-modal-right"
                                placement="left"
                                target={`drink-${item}`}
                                // container={'body'}
                              >
                                {t('gifts.serveDrink')}
                              </UncontrolledTooltip>
                            )}
                          </div>
                        ))}

                      </>
                  )}
                </Col>
              </Row>
            </div>
          )}
        />

        <CustomModal
          isOpen={confirmationModal}
          toggle={this.toggleConfirmModal}
          size="md"
          title={t('gifts.gifts')}
          footerClose
          footer={(
            <Fragment>
              <Button className="modal-footer-button" onClick={() => this.sendGift(giftId, drink)}>
                {t('common.yes')}
              </Button>
              <Button className="modal-footer-button" onClick={this.toggleConfirmModal}>
                {t('common.no')}
              </Button>
            </Fragment>
          )}
          body={(
            <div className="send-gifts-confirmation">
              {`${t('gifts.confirmation')} ${totalPrice} ${t('gifts.coins')}­ `}
            </div>
          )}
        />
      </div>
    );
  }
}


const mapStateToProps = state => ({
  gifts: state.rooms.gifts || {},
  drinkGifts: state.rooms.drinkGifts || {},
  popularGifts: state.rooms.popularGifts || {},
  fourPRoom: state.game.globalParams.fourPRoom,
  playerVIPInfo: state.rooms.playerVIPInfo || {},
  offset: state.member.offset,
});

const mapDispatchToProps = {
  setScreenViewNew: setUserScreenViewNew,
  setClosePlayerModalTriggerFunc: setClosePlayerModalTrigger
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(SendGiftMobile));
